import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../firebase/firebaseConfig";
import { signInWithEmailAndPassword } from "firebase/auth";
import ReCAPTCHA from "react-google-recaptcha";
import AuthLayout from "./ui/AuthLayout";
import Field from "./ui/Field";
import Button from "./ui/Button";

export default function Login() {
  const [user, setUser] = useState({
    email: "",
    password: "",
  });
  const [validated, setValidated] = useState(false);
  const [error, setError] = useState("");
  const captchaRef = useRef(null);

  const onRecaptchaChange = (value) => {
    if (value) setValidated(!!value);
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (auth?.currentUser) navigate("/");
  }, [navigate]);

  const onChangeHandler = (e) => {
    setUser((prevUser) => {
      return { ...prevUser, [e.target.name]: e.target.value };
    });
    if (error) setError("");
  };

  const submitHandler = (event) => {
    event.preventDefault();
    if (!validated) {
      setError("Please complete the reCAPTCHA first.");
      return;
    }
    signInWithEmailAndPassword(auth, user.email, user.password)
      .then((userCredential) => {
        localStorage.setItem("userCredential", JSON.stringify(userCredential));
        navigate("/upload");
      })
      .catch((err) => {
        console.error("login error", err?.code);
        setError("Incorrect email or password.");
        captchaRef.current?.reset();
        setValidated(false);
      });
  };

  return (
    <AuthLayout
      title="Welcome back"
      subtitle="Sign in to continue to Cloud Voice Processor."
      footer={
        <>
          Not a member yet?{" "}
          <a
            href="/signup"
            className="font-medium text-accent transition-colors hover:text-accent-soft"
          >
            Sign up
          </a>
        </>
      }
    >
      <form onSubmit={submitHandler} className="space-y-4">
        <Field
          label="Email"
          id="login-email"
          hideLabel
          type="text"
          name="email"
          value={user.email}
          onChange={onChangeHandler}
          autoComplete="email"
          placeholder="Email"
          required
        />
        <Field
          label="Password"
          id="login-password"
          hideLabel
          type="password"
          name="password"
          value={user.password}
          onChange={onChangeHandler}
          autoComplete="current-password"
          placeholder="Password"
          required
        />

        <div className="flex justify-end">
          <a
            href="/forgot-password"
            className="text-sm text-accent transition-colors hover:text-accent-soft"
          >
            Forgot password?
          </a>
        </div>

        {error && (
          <p role="alert" className="text-sm text-red-400">
            {error}
          </p>
        )}

        <div className="flex justify-center">
          <ReCAPTCHA
            ref={captchaRef}
            theme="dark"
            sitekey={"6Ldkj3EkAAAAAPYdhU4e2OOm2kjR1Kg_ChmA_h16"}
            onChange={onRecaptchaChange}
          />
        </div>

        <Button type="submit" variant="primary" className="w-full">
          Login
        </Button>
      </form>
    </AuthLayout>
  );
}
